import type { VedomostDocInfo } from '@entities/mto';
import { docOriginLabel, docStatusLabel, docStatusTone } from '@entities/mto';
import { Badge } from '@shared/ui/Badge';
import { Card } from '@shared/ui/Card';
import { IconChevronDown, IconChevronRight } from '@shared/ui/icons';
import {
  DocsTable,
  Name,
  SectionHead,
  Small,
  TableScroll,
  Toggle,
} from '../styles';

export function DocumentsCard({
  documents,
  docsOpen,
  onToggleDocsOpen,
}: {
  documents: VedomostDocInfo[];
  docsOpen: boolean;
  onToggleDocsOpen: () => void;
}) {
  const notIncluded = documents.filter((d) => d.status !== 'ok');

  return (
    <Card>
      <SectionHead>
        <Toggle type="button" aria-expanded={docsOpen} onClick={onToggleDocsOpen}>
          {docsOpen ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />}
          Документы ведомости <Badge $tone="neutral">{documents.length}</Badge>
          {notIncluded.length > 0 && (
            <Badge $tone="warning">не вошли: {notIncluded.length}</Badge>
          )}
        </Toggle>
      </SectionHead>
      {docsOpen && (
        <TableScroll tabIndex={0} role="region" aria-label="Документы ведомости">
          <DocsTable>
            <thead>
              <tr>
                <th scope="col">Документ</th>
                <th scope="col">Откуда</th>
                <th scope="col">Состояние</th>
                <th scope="col" className="num">
                  Строк
                </th>
              </tr>
            </thead>
            <tbody>
              {documents.map((d) => (
                <tr key={`${d.label}-${d.revision_id ?? d.filename ?? ''}`}>
                  <td>
                    <Name>{d.label}</Name>
                    {d.title && <Small>{d.title}</Small>}
                    {d.note && <Small>{d.note}</Small>}
                  </td>
                  <td>{docOriginLabel(d.origin)}</td>
                  <td>
                    <Badge $tone={docStatusTone(d.status)}>{docStatusLabel(d.status)}</Badge>
                  </td>
                  <td className="num">{d.rows}</td>
                </tr>
              ))}
            </tbody>
          </DocsTable>
        </TableScroll>
      )}
    </Card>
  );
}
